export default __webpack_public_path__ + "static/media/podesim.aa4448e1.png";